import React, { useEffect, useState } from "react";

import TarifBlock from "../../common/TarifBlock";
import { useFormikContext, useField, Form, Field } from "formik";
import { useData } from "../../utils/dataProvider";
import { useParams, useNavigate } from "react-router-dom";
import DatePicker, { registerLocale } from "react-datepicker";
import de from "date-fns/locale/de";
import axios from "axios";
import { url } from "../../utils/config";
import Loader from "../../common/loader";

import "react-datepicker/dist/react-datepicker.css";
registerLocale("de", de);

export default function DatenFormular({ data }) {
  const { values, setFieldValue, errors, touched, validateForm, isSubmitting } =
    useFormikContext();
  const [singleTarif, setSingleTarif] = useState(null);
  const [titleAbsolute, setTitleAbsolute] = useState(false);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    let idx = data.findIndex((ele) => ele.ID == values.tarif);
    setSingleTarif(data[idx]);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", TarifFixed);
  }, []);

  useEffect(() => {}, [errors]);

  function TarifFixed() {
    if (window.pageYOffset > 300) {
      setTitleAbsolute(window.pageYOffset);
    } else {
      setTitleAbsolute(false);
    }
  }

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {singleTarif && (
        <div
          className="float-block"
          style={
            titleAbsolute
              ? {
                  position: "fixed",
                  top: `16px`,
                  left: (window.innerWidth - 1000) / 2 - 308,
                }
              : { position: "absolute" }
          }
        >
          <TarifBlock data={singleTarif} values={values} />
        </div>
      )}
      <div className="formular">
        <div className="formular-headline">Vorversicherung </div>
        <div className="line-one-input">
          <div className="ec-label">Wie nutzen Sie das Fahrzeug?</div>
          <div className="select">
            <div
              onClick={() => {
                setFieldValue("vorversicherung", null);
              }}
              className={`select-block ${
                !values.vorversicherung ? "aktiv" : ""
              }`}
            >
              <div className="select-name">
                Ich möchte einen Fahrzeugwechsel vornehmen oder ein zusätzliches
                Fahrzeug versichern.
              </div>
              <div className="choose "></div>
            </div>
            <div
              onClick={() => {
                setFieldValue("vorversicherung", true);
              }}
              className={`select-block ${
                values.vorversicherung ? "aktiv" : ""
              }`}
            >
              <div className="select-name">
                Ich möchte mit meinem bereits angemeldeten Fahrzeug zu Ihnen
                wechseln.
              </div>
              <div className="choose "></div>
            </div>
          </div>
        </div>
        {values.vorversicherung ? (
          <>
            <div className="line-two-input">
              <div>
                <label className="ec-label">
                  Name der Vorversicherung*
                  <Field name="insurer" />
                </label>
                {errors.insurer && touched.insurer && (
                  <div className="ec-error">{errors.insurer}</div>
                )}
              </div>
              <div>
                <label className="ec-label">
                  Versicherungsnummer*
                  <Field name="insuranceNumber" />
                </label>
                {errors.insuranceNumber && touched.insuranceNumber && (
                  <div className="ec-error">{errors.insuranceNumber}</div>
                )}
              </div>
            </div>
            <div className="line-two-input">
              <div>
                <label className="ec-label">
                  Wurden in den letzten drei Jahren Schäden gemeldet?
                  <Field as="select" name="damageBefore">
                    <option value={true}>Ja</option>
                    <option value={false}>Nein</option>
                  </Field>
                </label>
              </div>
              <div>
                <label className="ec-label">
                  Wenn ja, wie viele?
                  <Field name="damageCount" className="number" type="number" />
                </label>
              </div>
            </div>
            <div className="line-two-input">
              <div>
                <label className="ec-label">
                  Wenn ja, wie hoch war die Gesamtentschädigung?
                  <Field name="damageAmount" />
                </label>
              </div>
              <div>
                <label className="ec-label">
                  Wurde der Vertrag von der Vorversicherung gekündigt?
                  <Field as="select" name="insurerCancled">
                    <option value={true}>Ja</option>
                    <option value={false}>Nein</option>
                  </Field>
                </label>
              </div>
            </div>
            <div className="line-two-input">
              <div>
                <label className="ec-label">
                  Gewünschtes Wechseldatum *
                  <br />
                  <br />
                  <DatePicker
                    className="calendar"
                    dateFormat="P"
                    locale="de"
                    selected={values.changeDate}
                    onChange={(val) => {
                      setFieldValue("changeDate", val);
                    }}
                  />
                </label>
                {errors.changeDate && (
                  <div className="ec-error">{errors.changeDate}</div>
                )}
              </div>
              <div>
                <label className="ec-label">
                  Möchten Sie Ihren SFR übertragen und im Vertragshintergrund
                  fortführen?
                  <Field as="select" name="sfrContinue">
                    <option value={true}>Ja</option>
                    <option value={false}>Nein</option>
                  </Field>
                </label>
              </div>
            </div>
          </>
        ) : (
          <div
            className="line-two-input"
            style={{ gridTemplateColumns: "1fr 1fr 1fr" }}
          >
            <div>
              <label className="ec-label">
                Möchten Sie Ihren SFR übertragen und im Vertragshintergrund
                fortführen?
                <Field as="select" name="sfrContinue">
                  <option value={"Ja"}>Ja</option>
                  <option value={"Nein"}>Nein</option>
                </Field>
              </label>
            </div>
            {values.sfrContinue === "Ja" ? (
              <>
                <div>
                  <label className="ec-label">
                    Name der Vorversicherung
                    <br />
                    <br />
                    <Field name="insurer" />
                  </label>
                  {errors.insurer && touched.insurer && (
                    <div className="ec-error">{errors.insurer}</div>
                  )}
                </div>
                <div>
                  <label className="ec-label">
                    Vorversicherungsscheinnummer
                    <br />
                    <br />
                    <Field name="insuranceNumber" />
                  </label>
                  {errors.insurer && touched.insurer && (
                    <div className="ec-error">{errors.insurer}</div>
                  )}
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
      <div
        className="formular"
        style={{
          marginTop: 32,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="formular-headline">Ihre Daten </div>
        <div className="line-two-input">
          <div>
            <label className="ec-label">
              Anrede
              <Field as="select" name="salutation">
                <option value="Herr">Herr</option>
                <option value="Frau">Frau</option>
                <option value="Divers">Divers</option>
              </Field>
            </label>
          </div>
          <div>
            {values.privat ? (
              <>
                <label className="ec-label">
                  Geburtstag {values.legalProtection && "*"}
                  <DatePicker
                    className="calendar"
                    dateFormat="P"
                    locale="de"
                    selected={values.birthday}
                    onChange={(val) => {
                      setFieldValue("birthday", val);
                    }}
                  />
                </label>
                {errors.birthday && touched.birthday && (
                  <div className="ec-error">{errors.birthday}</div>
                )}
              </>
            ) : (
              <div>
                <label className="ec-label">
                  Firma*
                  <Field name="company"></Field>
                </label>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Field
                    type="checkbox"
                    name="vorsteuer"
                    style={{
                      height: 12,
                      width: 12,
                      marginRight: 4,
                      marginTop: 16,
                    }}
                  />
                  <div
                    style={{
                      opacity: 0.5,
                      fontSize: 12,
                    }}
                  >
                    Das Unternehmen ist vorsteuerabzugsberechtigt.
                  </div>
                </label>
              </div>
            )}
          </div>
        </div>
        <div className="line-two-input">
          <div>
            <label className="ec-label">
              Vorname*
              <Field name="prename"></Field>
            </label>
            {errors.prename && touched.prename && (
              <div className="ec-error">{errors.prename}</div>
            )}
          </div>
          <div>
            <label className="ec-label">
              Nachname*
              <Field name="name"></Field>
            </label>
            {errors.name && touched.name && (
              <div className="ec-error">{errors.name}</div>
            )}
          </div>
        </div>
        <div className="line-two-input">
          <div>
            <label className="ec-label">
              Straße und Hausnummer*
              <Field name="street"></Field>
            </label>
            {errors.street && touched.street && (
              <div className="ec-error">{errors.street}</div>
            )}
          </div>
          <div>
            <label className="ec-label">
              Ort*
              <Field name="city"></Field>
            </label>
            {errors.city && touched.city && (
              <div className="ec-error">{errors.city}</div>
            )}
          </div>
        </div>
        <div className="line-two-input">
          <div>
            <label className="ec-label">
              Postleitzahl*
              <Field name="zip"></Field>
            </label>
            {errors.zip && touched.zip && (
              <div className="ec-error">{errors.zip}</div>
            )}
          </div>
          <div>
            <label className="ec-label">
              Land*
              <select className="ec-label">
                <option value="Deutschland">Deutschland</option>
                <option disabled value="none">
                  Nicht in anderen Ländern verfügbar.
                </option>
              </select>
            </label>
          </div>
        </div>
        <div className="line-two-input">
          <div>
            <label className="ec-label">
              E-Mail-Adresse*
              <Field name="email"></Field>
            </label>
            {errors.email && touched.email && (
              <div className="ec-error">{errors.email}</div>
            )}
          </div>
          <div>
            <label className="ec-label">
              Telefon*
              <Field name="phone"></Field>
            </label>
            {errors.phone && touched.phone && (
              <div className="ec-error">{errors.phone}</div>
            )}
          </div>
        </div>
        <div className="line-two-input">
          <div>
            <label className="ec-label">
              Ihre Nachricht
              <Field as="textarea" name="message"></Field>
            </label>
          </div>
          <label style={{ display: "flex", marginTop: "3rem" }}>
            <Field type="checkbox" name="datenschutz" />
            <div
              style={{
                opacity: 0.5,
                fontSize: 12,
                color: errors.datenschutz ? "red" : "#001835",
              }}
            >
              Ich akzeptiere die Datenschutzbedingungen und bin damit
              einverstanden, zum Zweck eines individuellen Angebots von der
              Schmitz Horn Treber GmbH und deren Kooperationspartnern der
              Michael Much GmbH und der SHT Versicherungsmakler GmbH kontaktiert
              zu werden
            </div>
          </label>
        </div>
        {isSubmitting ? (
          <div
            className="submit-btn"
            style={{
              width: 304,
              height: 60,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Loader height={40} width={40}></Loader>
          </div>
        ) : (
          <button type="submit" className="submit-btn">
            Jetzt abschicken
          </button>
        )}
      </div>
    </div>
  );
}
